const locale = {
  TITLE: 'Pharmacy management',
  COUNT_SUMMARY_TOTAL: 'Total {{count}} Pharmacies',
  COUNT_SUMMARY_ACTIVE: '{{count}} Active',
  COUNT_SUMMARY_INACTIVE: '{{count}} Inactive',
  COUNT_SUMMARY_READONLY: '{{count}} Read-Only',
  HEADER_SEARCH_TEXT_PLACEHOLDER: 'Search Pharmacy...',
  PHARMACY_STATUS: 'Pharmacy Status',
  DISPENSING_SYSTEM_FILTER: 'Dispensing System',
  DISPENSING_SYSTEM_NONE: 'None',
  ACTIVE: 'Active',
  IN_ACTIVE: 'Inactive',
  HEADER_BUTTON_NEW_FULL: 'Add A Pharmacy',
  HEADER_BUTTON_NEW_SHORT: 'New',
  HEADER_BUTTON_MIGRATE_PATIENT: 'Migrate Patients',
  PHARMACY_DETAIL: 'Pharmacy Details',
  PHARMACY_NAME: 'Pharmacy Name',
  PHARMACY_CONFIGURATION: 'Pharmacy Configuration',
  PHARMACY_DATA_UPLOAD: 'Data Sync {{ isSa }}',
  PHARMACY_TOOLS: 'Others',
  VPB_HISTORY_SUMMARY_BACKFILL_TITLE: 'VPB History Summary',
  VPB_HISTORY_SUMMARY_BACKFILL_ABOUT: 'About this tool',
  VPB_HISTORY_SUMMARY_BACKFILL_INTRO:
    'Rebuilds the VPB History Summary from raw VPB history for all balances in this pharmacy. When summary reading is on, VPB history uses the summary collection; when off, reads use raw history.',
  VPB_HISTORY_SUMMARY_BACKFILL_STEPS: 'VPB History Summary setting and Rebuild',
  VPB_HISTORY_SUMMARY_BACKFILL_STEP_1:
    'Enable — queues a full backfill. Summary reading is turned on only after the Hangfire job completes successfully (you will be asked to confirm).',
  VPB_HISTORY_SUMMARY_BACKFILL_STEP_2:
    'Disable — turns off summary reading immediately; users see raw VPB history again.',
  VPB_HISTORY_SUMMARY_CURRENT_STATUS: 'Current status: {{ status }}',
  VPB_HISTORY_SUMMARY_STATUS_RUNNING: 'Migrating',
  BUTTON_ENABLE_VPB_HISTORY_SUMMARY: 'Enable',
  BUTTON_DISABLE_VPB_HISTORY_SUMMARY: 'Disable',
  VPB_HISTORY_SUMMARY_BACKFILL_STEP_3:
    'Rebuild — queues a full backfill to refresh summary data. Summary reading is enabled when the job completes if it was off; if already on, it stays on.',
  VPB_HISTORY_SUMMARY_BACKFILL_TOOLTIP: 'Queues a background job; summary reading is enabled when it completes',
  VPB_HISTORY_SUMMARY_BACKFILL_CONFIRM_TITLE: 'Start VPB History Summary backfill?',
  VPB_HISTORY_SUMMARY_BACKFILL_CONFIRM_CONTENT:
    'A background job will rebuild the summary for all balances. VPB History Summary reading will be turned on when the job completes successfully. Check Hangfire for progress.',
  VPB_HISTORY_SUMMARY_ENABLE_CONFIRM_TITLE: 'Enable VPB History Summary?',
  VPB_HISTORY_SUMMARY_ENABLE_CONFIRM_CONTENT:
    'A background job will rebuild the summary histories for all balances before this feature is enabled.',
  VPB_HISTORY_SUMMARY_ENABLE_QUEUED_MESSAGE:
    'VPB History Summary backfill has been queued. Summary reading will be enabled when the job completes successfully.',
  VPB_HISTORY_SUMMARY_DISABLED_MESSAGE: 'VPB History Summary reading has been disabled.',
  BUTTON_VPB_HISTORY_SUMMARY_BACKFILL: 'Rebuild',
  VPB_HISTORY_SUMMARY_BACKFILL_QUEUED_ENABLE_ON_SUCCESS_MESSAGE:
    'VPB History Summary backfill has been queued. Summary reading will be enabled when the job completes successfully.',
  PHARMACY_DATA_SYNC_MIGRATION: 'Data Synchronisation {{ isSa }}',
  PHARMACY_DATA_CONFIG: 'Datalake Configuration',
  NAME: 'Name',
  CODE: 'Pharmacy ID',
  APPROVAL_NUMBER: 'Approval Number',
  STATE: 'State',
  READONLY: 'Read-Only Mode',
  MYPAK_INTEGRATION: 'myPakSync',
  MYPAK_INTEGRATION_CONFIRM_TITLE: 'myPakSync Integration',
  MYPAK_INTEGRATION_CONFIRM_CONTENT:
    'Are you sure you want to {{ action }} myPakSync integration for pharmacy {{ name }}?',
  MYPAK_INTEGRATION_ACTION_ENABLE: 'enable',
  MYPAK_INTEGRATION_ACTION_DISABLE: 'disable',
  MYPAK_INTEGRATION_SUCCESS: 'myPakSync integration has been changed successfully',
  EMAIL: 'Email',
  GUID: 'Guid',
  PHONE: 'Phone',
  FAX: 'Fax',
  STREET: 'Address',
  SUBURB: 'Suburb',
  POSTAL_CODE: 'Postcode',
  DOSE_ADD: 'DoseAid',
  TIMEZONE: 'Time zone',
  VALIDATION_TIMEZONE_INVALID_FOR_STATE: 'Selected timezone is not valid for the selected state',
  LOGO: 'Pharmacy Logo',
  IS_INTERGRATOR: 'Integration Partner',
  INTEGRATION_GUID: 'Integration GUID',
  ADD_PHARMACY_SUCCESS: 'Pharmacy has been added successfully',
  UPDATE_PHARMACY_SUCCESS: 'Pharmacy has been updated successfully',
  UPDATE_PHARMACY_CONFIGURATION_SUCCESS: "Pharmacy's configuration has been updated successfully",
  BUTTON_ADD_EMAIL: 'Add new email',
  BUTTON_ADD_GUID: 'Add new GUID',
  BUTTON_ADD_PHONE: 'Add new phone',
  BUTTON_ADD_FAX: 'Add new fax',
  MIGRATE_PATIENT_MESSAGE: 'Do you want to execute this action ?',
  MIGRATE_PATIENT_TITLE: 'Migrate Patients',
  MIGRATE_PATIENT_SUCCESS: 'Migrate Patients successfully',
  RESEND_INVITE_EMAIL_BUTTON: 'Resend Invite Email',
  RESEND_INVITE_EMAIL_MESSAGE: 'Send email successfully',
  REQUEST_SYNC_MESSAGE: 'Request sync data successfully',
  MIGRATE_BUTTON_IMPORT: 'Import',
  MIGRATE_FACILITY_IMPORTED_LABEL: 'Facility to be imported',
  MIGRATE_PATIENT_IMPORTED_LABEL: 'Patient to be imported',
  MIGRATE_FACILITY: 'Facility',
  MIGRATE_PATIENT_COUNT: 'Patient Count',
  MIGRATE_LAST_UPDATED: 'Last Updated',
  CONFIGURATION_DISPENSING_SYSTEM: 'Dispensing System',
  CHANGE_DISPENSING_SYSTEM_CONFIRM_TITLE: 'Change Dispensing System',
  CHANGE_DISPENSING_SYSTEM_CONFIRM_CONTENT:
    'Changing the dispensing system will remove all existing SCRIPTS data from the previous dispensing system.\nDo you want to continue?',
  CONFIGURATION_FRED_PAK_STATUS_ACTIVE: 'Fred Pak Status Active',
  CONFIGURATION_MINFOS_SERVER_URL: 'WebService URL',
  CONFIGURATION_MINFOS_BUSINESS_CODE: 'Business Code',
  CONFIGURATION_MINFOS_USER_NAME: 'Username',
  CONFIGURATION_MINFOS_USER_PASSWORD: 'Password',
  CONFIGURATION_LOTS_SQL_HOST: 'SQL Hostname',
  CONFIGURATION_LOTS_SQL_DATABASE: 'SQL Database',
  CONFIGURATION_LOTS_SQL_USER_NAME: 'SQL Username',
  CONFIGURATION_LOTS_SQL_USER_PASSWORD: 'SQL Password',
  CONFIGURATION_FRED_DATABASE_FOLDER: 'FRED DBFS Folder',
  CONFIGURATION_FRED_PATH_FOR_DORPTS: 'Path to create DORPTS',
  CONFIGURATION_FRED_PAK_PATH: 'FREDPak DBFS Folder',
  CONFIGURATION_PHARMACY_GUID: 'Pharmacy Guid',
  CONFIGURATION_SYNC_COLLECTION: 'Sync Collection',
  CONFIGURATION_MAX_DAYS_TO_CHECK_SCRIPT: 'Max Days To Check Script',
  CONFIGURATION_HUB_AND_SPOKE_EXPORT_FOLDER: 'Hub & Spoke Export Folder',
  CONFIGURATION_QUEUE_NAME_FOR_ANOTHER_PHARMACY: 'Queue Name For Another Pharmacy',
  CONFIGURATION_PACK_MANAGEMENT_STAGES: 'Pack Management Stages',
  CONFIGURATION_CORUM_CLEAR_PATH: 'Path to Corum ClearConnect Utility',
  CONFIGURATION_CORUM_IDENTIFIER: 'Corum ClearConnect Unique Identifier',
  CONFIGURATION_Z_API_URL: 'Api URL',
  CONFIGURATION_Z_VENDOR_ACCESS_KEY: 'Vendor Access Key',
  CONFIGURATION_Z_STORE_ACCESS_KEY: 'Store Access Key',
  CONFIGURATION_Z_BATCH_ID: 'Batch Id',
  CONFIGURATION_Z_USER_NAME: 'User Name',
  CONFIGURATION_FRED_NXT_API: 'FredNXT API URL',
  CONFIGURATION_FRED_NXT_ACCESS_KEY: 'FredNXT Access Key',
  CONFIGURATION_FRED_NXT_SUBSCRIPTION_KEY: 'FredNXT Subscription Key',
  BUTTON_ADD_SYNC_COLLECTION: 'Add collection',
  BUTTON_START_DATA_MIGRATION: 'Start Desktop Migration',
  BUTTON_REFRESH_DISPENSE: 'Refresh Dispense',
  BUTTON_REQUEST_SYNC_DATA: 'Request Data Sync',
  BUTTON_DOWNLOAD_DATALAKE: 'Download configuration',
  BUTTON_UPLOAD_DRUG: 'Upload Drug',
  DATA_UPLOAD_DATA_MIGRATION_MESSAGE: 'Migrate data is started',
  DATA_UPLOAD_DISPENSE_REFRESH_MESSAGE: 'Dispense refresh is not finished',
  PRINTER_SETTING: 'Printer Settings',
  BLISTER_TYPE: 'Blister Type',
  DEFAULT_PRINTER: 'Default Printer',
  REMOVE_PRINTER_SETTING_CONFIRM_TITLE: 'Remove Printer Setting',
  REMOVE_PRINTER_SETTING_CONFIRM_CONTENT: 'Are you sure you want to remove this setting',
  ADD_PRINTER_SETTING_BUTTON: 'Add Printer Setting',
  REMOVE_PRINTER_SETTING_SUCCESS: 'The settings for this Blister Type is successfully removed',
  UPDATE_PRINTER_SETTING_SUCCESS: 'The settings for this Blister Type is successfully updated',
  CREATE_PRINTER_SETTING_SUCCESS: 'The settings for this Blister Type is successfully created',
  REQUEST_SYNC_TOOLTIP: 'Request to sync data from myPak.Desktop',
  REQUEST_SYNC_TOOLTIP_DISABLED: 'Please enter Pharmacy GUID',
  START_DATA_MIGRATION_TOOLTIP: 'Start migrate staging data to live data',
  REFRESH_DISPENSE_TOOLTIP: 'Refresh dispense data from the on-prem dispense system',
  DESKTOP_SYNC_DATA_TITLE: 'myPak Desktop Data Migration',
  DISPENSE_INTEGRATED_DATA_TITLE: 'Dispense Data Sync',
  START_DATA_MIGRATION_NOTE: 'Migrate data from myPak Desktop to myPak NG',
  DELETE_PHARMACY_SUCCESS: 'Pharmacy has been deleted successfully',
  BUTTON_DELETE_PHARMACY: 'Delete pharmacy',
  BUTTON_ENABLE_READONLY_MODE: 'Enable Read-Only Mode',
  BUTTON_DISABLE_READONLY_MODE: 'Disable Read-Only Mode',
  DELETE_PHARMACY_CONFIRM_CONTENT: 'Are you sure you want to delete pharmacy {{ name }} ?',
  DELETE_PHARMACY_CONFIRM_TITLE: 'Delete Pharmacy',
  READONLY_MODE_CONFIRM_CONTENT: 'Are you sure you want to {{ action }} Read-Only mode ?',
  READONLY_MODE_CONFIRM_TITLE: 'Read-Only Mode',
  READONLY_MODE_SUCCESS: 'Read-Only mode has been changed successfully',
  BUTTON_SELECT_IMAGE: 'Select Image',
  BUTTON_SAVE_IMAGE: 'Save Image',
  UPLOAD_LOGO_REQUIRED_MESSAGE: 'Click Save Image to upload logo',
  CONFIGURATION_STAGES_PRINTING: 'Printing',
  CONFIGURATION_STAGES_PACKING: 'Packing',
  CONFIGURATION_STAGES_CHECKING: 'Checking',
  CONFIGURATION_STAGES_DISTRIBUTION: 'Distribution',
  VIRTUAL_PILL_BALANCE: 'Virtual Pill Balance',
  DISPLAY_VPB_IN_CHECKING_PHRASE: 'Display VPB in Checking Phase',
  CONFIGURATION_ENABLE_VPB_HISTORY_SUMMARY: 'VPB History Summary',
  QSCRIPT_FEATURE: 'QScript Feature',
  DISPENSE_TRACKER: 'Dispense Tracker',
  MIGRATION_PROCESS_COMPLETED:
    'The migration was completed before. Would you like to reset the pharmacy database and start again.',
  MIGRATION_PROCESS_IS_RUNNING: 'Another the migration process is running. Please try again later.',
  CONFIGURATION_DW_HOST: 'Host / Server',
  CONFIGURATION_DW_DB_NAME: 'Database',
  CONFIGURATION_DW_TRUSTED_CONNECTION: 'Trusted Connection',
  CONFIGURATION_DW_USER_NAME: 'User Name',
  CONFIGURATION_DW_USER_PASSWORD: 'Password',
  CONFIGURATION_DW_QSCRIPT_EXPORT_FOLDER: 'QScript Export Folder',
  CONFIGURATION_FRED_DISPENSE_PLUS_API_URL: 'Fred Dispense Plus API URL',
  CONFIGURATION_FRED_DISPENSE_PLUS_API_KEY: 'Fred Dispense Plus API Key',
  CONFIGURATION_FRED_DISPENSE_PLUS_SUBSCRIPTION_KEY: 'Fred Dispense Plus Subscription Key',
  CONFIGURATION_LOG_OUT_TIME: 'Log out due to inactivity (Mins)',
  CONFIGURATION_COLLAPSE_MENU_BAR: 'Collapse Menu Bar',
  CONFIGURATION_USE_GLOBAL_DRUG: 'Use Global Drug',
  CONFIGURATION_BRAND_SWAP_PROFILE_CHANGE_ALERT: 'Brand Swap Profile Change Alert',
};

export default locale;
